import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import MILogo from "../../images/MI-Image.png";
import axios from "axios";
import { formatCurrency } from "../../utlis/utlis";
import Loading from "../../utlis/Loading";

const VisaMasterCheckoutForm = () => {
  const [searchParams] = useSearchParams();
  const paymentToken = searchParams.get("paymentToken");
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const redirectUrl = "https://testsecureacceptance.cybersource.com/pay";

  // const redirectUrl = "https://secureacceptance.cybersource.com/pay";
  useEffect(() => {
    if (paymentToken) {
      initiatePayment();
    } else {
      setMessage("Payment token is missing. Please try again.");
    }
  }, []);

  const initiatePayment = async () => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/card/visa-master`,
        null,
        { params: { token: paymentToken } }
      );
      console.log("RES", response.data);
      setResponseData(response.data);
    } catch (error) {
      console.error("Payment initiation failed:", error);
      setMessage("Failed to initiate payment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const createAndSubmitForm = () => {
    if (!responseData) {
      setMessage("Payment data not available. Please try again.");
      return;
    }

    console.log("REdirect", redirectUrl);
    
    alert("redirect")
    const form = document.createElement("form");
    form.method = "post";
    form.action = redirectUrl;
    form.style.display = "none";

    Object.entries(responseData).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  return loading ? (
    <Loading />
  ) : (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center">
        <img
          src={MILogo}
          alt="Logo"
          className="me-2"
          style={{ objectFit: "cover" }}
        />
      </div>

      <div className="mt-3">
        <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>
        <div className="table-responsive">
          <table className="table" style={{ fontSize: "16px", width: "auto" }}>
            <tbody>
              <tr>
                <td
                  style={{ width: "55%", fontWeight: "bold" }}
                  className="text-start"
                >
                  Total Amount:
                </td>
                <td className="text-end" style={{ fontWeight: "bold" }}>
                  {formatCurrency(
                    Number(responseData?.amount ?? 0),
                    responseData?.currency
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Transaction Amount:
                </td>
                <td className="text-end">
                  {formatCurrency(
                    Number(responseData?.amount ?? 0) -
                      Number(responseData?.serviceFee ?? 0),
                    responseData?.currency
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Service Fee:
                </td>
                <td className="text-end">
                  {formatCurrency(
                    responseData?.serviceFee,
                    responseData?.currency
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%" }} className="text-start">
                  Invoice No.:
                </td>
                <td className="text-end">
                  {responseData?.reference_number || "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container mt-4">
        <h5>VISA/MASTER Card Payment</h5>
        <div
          className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center"
          style={{ minHeight: "50vh", padding: "1rem" }}
        >
          <div className="d-flex flex-column flex-md-row w-100 w-md-auto">
            <button
              className="btn btn-primary"
              disabled={loading || !responseData}
              onClick={createAndSubmitForm}
            >
              {loading ? "Processing..." : "Pay with Visa/Master TEST"}
            </button>
          </div>
          {message && <div className="mt-3 w-100 text-danger">{message}</div>}
        </div>
      </div>
    </div>
  );
};

export default VisaMasterCheckoutForm;
